<template>
  <div>
    <p class='mb-5'>{{ 'report-of-sickness.form.new-description-multi' | translate}}</p>

    <TextField :placeholder="$t('input.placeholders.who-are-you-looking-for')" class="mb-4" v-model="search">
      <v-icon slot='left'>search</v-icon>
    </TextField>

    <v-data-table
      :headers="headers"
      :items="employees"
      :loading="isEmployeesLoading"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="[5, 10, 25, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
      rows-per-page-text='Rijen per pagina'>
      <v-progress-linear slot='progress' color='#cdd2dc' indeterminate></v-progress-linear>
      <template slot='items' slot-scope='props'>
        <tr
          @click="() => handleSelectEmployee(props.item)"
          v-on:dblclick="handleSelectEmployeeAndContinue(props.item)"
          :class="props.item.id === selectedEmployeeId ? 'selected' : ''"
          style='cursor: pointer;'>

          <td>{{ props.item.getName() }}</td>
          <td>{{ props.item.getNamePartner() }}</td>

          <td>{{ getFormattedDateOfBirth(props.item.dateOfBirth) }}</td>
          <td>{{ props.item.employeeNumber }}</td>
        </tr>
      </template>

      <div class='no-results-badge' slot='no-results'>
        <v-icon>warning</v-icon>
        <p>{{ 'errors.no-results-found-for' | translate }}
          <span>{{ search }}</span>.
        </p>
      </div>
    </v-data-table>

    <div style='float: right' class='mt-4'>
      <Button primary class='mr-3' @click="handleCancelClick">{{ 'buttons.cancel' | translate }}</Button>
      <template v-if="isValid">
        <Button secondary @click="this.handleContinueClick" :disabled="!isValid">
          {{ 'buttons.next-step' | translate }}
        </Button>
      </template>
      <template v-if="!isValid">
        <v-tooltip top color='#fd4160'>
          <Button secondary @click="this.handleContinueClick" :disabled="!isValid" slot='activator'>
            {{ 'buttons.next-step' | translate }}
          </Button>
          <span>{{ 'report-of-sickness.form.select-employee' | translate }}</span>
        </v-tooltip>
      </template>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import HelperFunctions from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';
import Modal from '@/shared/constants/modal';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';

import NRS from '@/views/constants/report-of-sickness-new';
import Employees from '@/resources/constants/employees';

export default {
  name: 'SelectEmployeeForm',
  data () {
    return {
      headers: [
        { text: this.$t('employee.name'), value: 'lastName' },
        { text: this.$t('employee.last-name-partner'), value: 'lastNamePartner' },
        { text: this.$t('employee.date-of-birth'), value: 'dateOfBirth' },
        { text: this.$t('employee.id'), value: 'employeeNumber' },
        { text: '', value: 'search', width: '0px' }
      ],
      search: '',
      pagination: {
        sortBy: 'lastName',
        descending: false,
        rowsPerPage: 25
      }
    };
  },
  components: {
    Button,
    TextField
  },
  mounted () {
    this.$store.dispatch(Employees.Actions.LoadAll.START, this.$store.getters.selectedEmployer.id);
  },

  computed: {
    employees () {
      const employees = this.$store.getters.employees;
      employees.forEach(e => {
        e.search = e.getSearchString();
      });
      return employees;
    },
    reportsOfSickness () {
      return this.$store.getters.reportsOfSickness;
    },
    isEmployeesLoading () {
      return this.$store.getters.isEmployeesLoading;
    },
    selectedEmployeeId () {
      return this.$store.getters.newReportOfSickness.employeeId;
    },
    isValid () {
      return !_.isNil(this.$store.getters.newReportOfSickness.employeeId);
    }
  },

  methods: {
    handleContinueClick () {
      this.$store.dispatch(
        NRS.Actions.Navigate.DO,
        NRS.Views.NewReportOfSicknessForm);
    },
    handleCancelClick () {
      this.$store.dispatch(
        NRS.Actions.Cancel.DO);
    },
    handleSelectEmployee (employee) {
      const activeReportOfSicknessForEmployee = Compositions.getActiveReportOfSicknessForEmployee(employee, this.reportsOfSickness);

      if (activeReportOfSicknessForEmployee != null) {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'AlreadyHasActiveReportOfSickness',
          reportOfSickness: activeReportOfSicknessForEmployee,
          employee: employee
        });
      } else {
        this.$store.dispatch(NRS.Actions.Form.CHANGE, {
          attribute: 'employeeId',
          value: employee.id
        }).then(this.$store.dispatch(NRS.Actions.Steps.Completed.UPDATE));
      }
    },
    handleSelectEmployeeAndContinue (employee) {
      this.handleSelectEmployee(employee);
      this.handleContinueClick();
    },
    getFormattedDateOfBirth (value) {
      return HelperFunctions.Dates.formatDate(value);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
